import { useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { RouteFactory } from "@app/routePaths";

/**
 * This hook updates the URL to reflect the active pulse article.
 * It uses the `useNavigate` hook from react-router-dom to change the URL.
 */
export const useHookUpdatePulseUrl = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const updatePulseUrl = useCallback(
    (activeId: string, displaySearchParams?: boolean) => {
      if (!activeId) return;
      const hasSearchParams = [...searchParams].length > 0;

      if (displaySearchParams && hasSearchParams) {
        navigate({
          pathname: RouteFactory.pulseSlide(activeId),
          search: searchParams.toString(),
        });

        return;
      }

      navigate(RouteFactory.pulseSlide(activeId));
    },
    [navigate, searchParams]
  );

  return { updatePulseUrl };
};
